export const arrayIsEmpty = (array: Array<any>): boolean => {
  return Array.isArray(array) && array.length === 0
}
